import React, {useCallback, useEffect, useState} from 'react';
import {mostrarPrestamoById} from "../../redux/reducers/prestamosReducer"
import {useLocation, useNavigate} from "react-router-dom";
import {calCuotasPrestamo, postPago, postPagoInicial} from "../../services"
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Theme,
  Typography,
  useMediaQuery
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {DateInput, TextFieldCurrency} from "../../components/CustomTextField"
import {formatDate, formatPeso, getUsuTipo, hasPermissionTo, PERSMISOS, TIPOPAGO, TIPOUSUARIO} from "../../helpers";
import {LoadingProgress, MostrarError, TopBarDialog} from "../../components";
import {SelectCaja, SelectEnum, SelectFiles} from "../../components/selects";
import Strings from "../../assets/strings";
import defaultImg from "../../assets/img/reciboImg.jpg";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IPagoPost} from "../../redux/types/IPago";
import {IPrestamoDetalle} from "../../redux/types/IPrestamo";
import {Close, KeyboardArrowDown, Save} from "@mui/icons-material";
import {getValueString, objToKeyValue} from "../../helpers/CONSTANTES";
import {IKeyValue} from "../../redux/types/Icommon";

const useStyles = makeStyles((theme:Theme) => ({
  root: {
    boxShadow: "none",
    [theme.breakpoints.up('sm')]: {
      maxWidth:540,
      margin:"0px auto",
    },
    [theme.breakpoints.only('xs')]: {
      "& .MuiInput-input":{
        position: "relative",
        padding: 7,
        border: "1px solid #e6e6e6",
      },
      "& .MuiInputLabel-formControl:not(.MuiInputLabel-shrink)":{
        left:theme.spacing(1),

      }
    }
  },
  tabs:{
    minHeight: 37,
    "& button":{
      minHeight: 37,
      "&.Mui-selected":{
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
        borderTop: "1px solid rgba(0, 0, 0, 0.1)"
      }
    },
    "& .MuiTabs-indicator":{
      display:"none",
    }
  },
  content:{
    padding:theme.spacing(2),
  },
  cuotaInteres:{
    padding: theme.spacing(1),
    background: "#f3f3f3",
    marginBottom: theme.spacing(0.5),

    // display: "flex",
    // justifyContent: "flex-end",
    // fontSize: ".9em",
    // fontWeight: 600,
    // textAlign: "center",
    // //marginTop: 40,
    // marginBottom: 4,
    // "& span":{
    //   fontWeight: "normal",
    // },
    "&> div > div span": {
      "&:first-child":{
        fontWeight: "bold"
        },
      // "&:nth-child(2)": {
      //     marginRight: 5
      //   }
    }
  },
  montoInput:{
    background: "#f3f3f3",
    padding: theme.spacing(2),
    textAlign: "center",
    marginBottom: theme.spacing(2),
    "& .MuiInput-root":{
      margin:"0px !important",
    },
    "& input": {
      fontSize: "1em",
      color:theme.palette.primary.main,
      textAlign: "center",
      background: theme.palette.common.white,

      "&:disabled":{
        background: theme.palette.grey[100]
      }
    }
  },
  alertText:{
    background:theme.palette.primary.light,
    padding: "5px "+ theme.spacing(2),
    textAlign: "center",
    fontSize: ".9rem",
    color:theme.palette.secondary.contrastText,
  },
  dialogActions:{
   // justifyContent: "space-between",
    background: "#f8f8f8",
  },
  totalApagar:{
    padding: theme.spacing(1),
    display: "inline-block",
    fontWeight: 500,
    "& span":{
      color:theme.palette.secondary.main
    }
  },
  authMask:{ position: "absolute", height: "calc(100% - 16px)", width: "calc(100% - 16px)", zIndex: 1, cursor: "pointer" },
  abonoRest:{
    textAlign: "center",
    background: "#f3f3f3",
    marginTop: -14,
    marginBottom: 14,
    paddingTop: 6,
    "& *":{
     // fontSize: 14
    }
  }
}));
let initialState:IPagoPost = {
  prestamoId:0,
  tipoFormaPago:1,
  tipo: TIPOPAGO.CUOTA_COMPLETA,
  monto: 0,
  mora: undefined,
  otros: 0,
  descuento: 0,
  nota: "",
  fecha: "",
  cajaId: undefined,
  cuotasAPagar: undefined,
  abonarSobranteCapital: false,
  incluirSeguro: false,
  pin:""
};

export default function AddPago(){
  const classes = useStyles();
  const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
  let navigate = useNavigate();
  const {state:hState={}, pathname} = useLocation();
  let dispatch = useAppDispatch();
  let prestamo = useAppSelector(state => state.prestamos.byId || {} as IPrestamoDetalle);
  let defaultCajId = useAppSelector(state => state.auth.user?.cajaIdDefault);
  let {parametros} = useAppSelector(state => state.companias?.data ?? {});
  let modificarMora = parametros?.some(p=>p.parametro === 11);

  const [menuTipo, setMenuTipo] = React.useState<null | HTMLElement>(null);

  const [solAuthModal, setSolAuthModal] = useState(false);
  const [state, setState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [msj, setMsj] = useState("");
  const [montoApi, setMontoApi] = useState(0);

  useEffect(()=>{
    if (prestamo.id) {
      let obj:any ={
        prestamoId:prestamo.id,
        cuotasAPagar: !!prestamo.pagoPendiente? 0 : 1,
        fecha:""
      };

      if(modificarMora){
        obj.monto = !!prestamo.pagoPendiente? prestamo.pagoPendiente : 0;
        obj.mora = prestamo.mora
      }else{
        obj.monto = !!prestamo.pagoPendiente? (prestamo.pagoPendiente + (prestamo.mora ?? 0)) : 0;
      }

      //setear la caja por defecto al pagar, si tiene permiso
      let dCajId:number | undefined = undefined;
      if (getUsuTipo() !== TIPOUSUARIO.agente){ //titutar o admin
        dCajId = defaultCajId || prestamo.cajaId
      }else{
        if(defaultCajId === -1 || defaultCajId === prestamo.cajaId){
          dCajId = prestamo.cajaId;
        }else{
          dCajId = defaultCajId
        }
      }
      setState(prevState => ({...prevState,cajaId: dCajId, ...obj}));

      // getFechaHoraActual().then(({data})=>{
      //   setState(prevState => ({...prevState,cajaId: dCajId, ...obj,fecha:data}));
      // })
    }
  },[prestamo, modificarMora, setState,defaultCajId]);


  const calMonto = useCallback(async ()=>{
    let obj:any = {
      cuotasAPagar:state.cuotasAPagar??1,
      abonarSobranteCapital: false,
      monto:0
    }

    if(prestamo.id) {
      let mora =  modificarMora? 0 : (prestamo.mora ?? 0)
      if(state.cuotasAPagar === 0){
        return {monto: (prestamo.pagoPendiente??0) + mora}
      }
      switch (state.tipo) {

        case TIPOPAGO.CUOTA_COMPLETA:
          await calCuotasPrestamo(prestamo.id, obj.cuotasAPagar).then(({data}) => {
            obj = {monto: (+data + mora + (prestamo.pagoPendiente ?? 0)).toFixed(2)}
            setMontoApi(+data)
          })
          break
        case TIPOPAGO.SOLO_INTERES:
          obj = {
            monto: ((prestamo.cuotaInteres ?? 0) * obj.cuotasAPagar) + mora + (state.incluirSeguro ? (prestamo.montoSeguro ?? 0) * obj.cuotasAPagar : 0)
          }
          break
        case TIPOPAGO.PAGO_INICIAL:
          obj = {monto: prestamo.inicial ?? 0}
          break
        case TIPOPAGO.ABONO_CAPITAL:
          obj = { monto: mora ?? 0}
          break

        case TIPOPAGO.SALDAR:
          await calCuotasPrestamo(prestamo.id!, 0).then(({data}) => {
            obj = { monto: data + mora}
          })
          break
      }
    }
    return obj
  },[setMontoApi,modificarMora,prestamo, state.tipo, state.cuotasAPagar, state.incluirSeguro])

  useEffect(()=>{
    if(state.cuotasAPagar !== undefined){
      calMonto().then((value)=>{
        setState(prevState => ({...prevState, ...value}))
      }).catch(console.error)
    }
  },[calMonto,setState,state.cuotasAPagar]);

  //setear si es un pago pediente
  useEffect(()=>{
    if(Object.keys(hState?.modalPago ?? {}).length){
      const {id,fecha,adjuntoBase64,nota} = hState.modalPago;
      setState(prev=>({...prev,id,fecha,adjuntoBase64,nota:nota}))
    }
  },[hState])

 // watch changes on monto para validar
  const validate = useCallback(() => {
    const inputPagMonto:any = document.getElementById("monto");
    setMsj("");
    if(!!inputPagMonto) inputPagMonto.setCustomValidity("");

    const {tipo,monto} = state;
    const {cuotaInteres=0,capitalActual=0,cuotasAtrasadas=0} = prestamo

    let mora =  modificarMora ? 0 : (prestamo.mora ?? 0)


    switch (tipo) {
      // case TIPOPAGO.CUOTA_COMPLETA:
      //   if(monto < cuotaInteres * (cuotasAPagar??0)){
      //     setMsj(Strings.montoMayorInteresMsj+" " +cuotasAPagar+ " "+Strings.cuotas);
      //     if(!!inputPagMonto) inputPagMonto.setCustomValidity(Strings.montoMayorInteresMsj+" " +cuotasAPagar+ " "+Strings.cuotas)
      //   }
      //   break;
      case TIPOPAGO.SALDAR:
          let nC = (cuotasAtrasadas??0)>0?cuotasAtrasadas:1;
          if(Math.trunc(capitalActual + (nC*cuotaInteres)) === Math.trunc(monto)){
            setMsj(`${Strings.capitalActual} + ${Strings.interes} ${Strings.de} ${nC} ${Strings.cuotas}.`);
          }else {
            setMsj(`${Strings.capitalActual} + ${Strings.interes} ${Strings.de} ${Strings.cuotasRestantes}`);
          }
        break;
      case TIPOPAGO.ABONO_CAPITAL:
        if((monto - mora).toFixed(2) === capitalActual.toFixed(2)){
          setMsj(Strings.pagoCancelaMsj);
        }else if((monto - mora).toFixed(2) > capitalActual.toFixed(2)){
          setMsj(Strings.abonoMenosCapitalMsj)
         // if(!!inputPagMonto) inputPagMonto.setCustomValidity(Strings.abonoMenosCapitalMsj)
        }
        break;
      // case TIPOPAGO.PAGO_PARCIAL:
      //   if(monto > montoCuota){
      //     setMsj(Strings.parcialMenorCuota);
      //   }
      //   break;
      default:
        setMsj("");
        break
    }
  },[prestamo,modificarMora, state])

  useEffect(()=>{
    validate()
  },[validate])
 // end watch

  const handleChange = (e:React.ChangeEvent<HTMLInputElement>) => {
    const {value,name, type, checked} = e.target;
    if(name === "abonarSobranteCapital") return setState(prev=>(({...prev, abonarSobranteCapital:value==="capital"})))
    setState({...state,[name]:type==="number"?(value? +value : undefined):(type === "checkbox"?checked: value)});
  };
  const handleTipoChange = (tipo:number) => {
    let obj = {
      ...state,
      cuotasAPagar:(tipo === TIPOPAGO.CUOTA_COMPLETA && !!prestamo.pagoPendiente) ? 0:1,
      soloInteres:false,
      incluirSeguro:false,
      tipo: +tipo,
      abonarSobranteCapital: false
    };

    setState(obj);
    setMenuTipo(null)
  };


  const cuotasList = () => {
    let list:IKeyValue[] = [];
    let cuotasRestante = 1;
    let spl = prestamo.plazoString?.split("/");
    if(spl?.length === 2){
      cuotasRestante = parseInt(spl[1]) - parseInt(spl[0]);
      //if((prestamo.cuotasAtrasadas ?? 0) > cuotasRestante) cuotasRestante = prestamo.cuotasAtrasadas;

      //  if(cuotasRestante > 10) cuotasRestante = 10;
      if(cuotasRestante <= 0) cuotasRestante = 1;
    }

    for(let i = 1;i <= cuotasRestante;i++){
      list.push({
        key:i,
        value: i +" "+(i===1?Strings.cuota:Strings.cuotas)+" "+(i <= (prestamo.cuotasAtrasadas ?? 0) ? "("+Strings.pendiente+")":"" )
      });
    }

    if((prestamo.cuotasAtrasadas ?? 0) > cuotasRestante){
      for(let i = 1;i <= (prestamo.cuotasAtrasadas ?? 0) - cuotasRestante;i++){
        list.push({
          key:list.length + 1,
          value: list.length + 1 +" "+(i===1?Strings.cuota:Strings.cuotas)
        });
      }
    }
    return list
  }

  const submit = async (e:React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    let data = {...state};
    if(!data.fecha) delete data.fecha;




    // if (state.tipo === TIPOPAGO.PAGO_RAPIDO){
    //   delete data.mora
    //   delete data.cuotasAPagar
    //   delete data.tipo
    // }
    // else if (state.tipo === TIPOPAGO.PAGO_PARCIAL) {
    //   data.cuotasAPagar  = 0;
    //   if (state.monto === prestamo.pagoPendiente || cerrarCuota) {
    //     data.cuotasAPagar = 1;
    //   }
    // }
    if (state.tipo === TIPOPAGO.ABONO_CAPITAL ) {
      delete data.cuotasAPagar;
      delete data.descuento;
    }
    else if (state.tipo === TIPOPAGO.PAGO_INICIAL ) {
      delete data.cuotasAPagar;
      delete data.tipo;
      delete data.pin;
    }else if (state.tipo === TIPOPAGO.SALDAR ) {
      delete data.cuotasAPagar;
    }


    //no enviar adjunto si es el mismo
    if(hState?.modalPago.adjuntoBase64 === data.adjuntoBase64){
      delete data.adjuntoBase64
    }
    // let horaActual =  await getFechaHoraActual();
    // let fecha = state.fecha+""+horaActual.data?.substring(10);


    let request = state.tipo === TIPOPAGO.PAGO_INICIAL
        ? postPagoInicial(data)
        : postPago(data);


    request.then(({data})=>{
      dispatch(mostrarPrestamoById(prestamo.id!));
      navigate(pathname,{state:{recibo:data}, replace:true})
    }).catch(({response})=>{

      setError(response.data);
    }).finally(()=>setLoading(false))
  };

  const checkRestante = () => {
    let mora =  modificarMora ? 0 : (prestamo.mora ?? 0)

    let monto = ((state.monto ?? 0) - mora - (prestamo.pagoPendiente ?? 0) - (state.descuento ?? 0)).toFixed(2)
    return +monto - (state.cuotasAPagar === 0 ? 0 : montoApi)
  }

  return (
      <Dialog disableEscapeKeyDown className={classes.root} fullScreen={smVewport} fullWidth maxWidth={"sm"} open={true}>
        <TopBarDialog title={Strings.agregar+" "+Strings.pago} nofullScreen onClose={()=>navigate(-1)}>
          {!!hState?.modalPago?.totalPago &&
            <Typography sx={{mr:1}}>{formatPeso(hState?.modalPago.totalPago)}</Typography>
          }
        </TopBarDialog>



        {/*<Tabs variant={smVewport?"scrollable":"fullWidth"}*/}
        {/*      value={state.tipo === TIPOPAGO.PAGO_INICIAL ?state.tipo:TIPOPAGO.PAGO_RAPIDO}*/}
        {/*      onChange={(v,tipo)=>{*/}
        {/*        setState(prev => ({...prev, tipo: Math.abs(tipo)})) //-1 selecciona el tipo 1*/}
        {/*      }} indicatorColor={"secondary"} className={classes.tabs}>*/}
        {/*  <Tab value={TIPOPAGO.PAGO_RAPIDO} label={Strings.pagoRapido}  />*/}
        {/*  <Tab value={TIPOPAGO.PAGO_INICIAL} label={Strings.inicial} disabled={!prestamo.inicial}/>*/}
        {/*  /!*<Tab value={-2} label={Strings.avanzado} />*!/*/}
        {/*</Tabs>*/}


          <Button onClick={(event)=>setMenuTipo(event.currentTarget)} color={"primary"} sx={{background:"#eaeaea",borderBottom:"1px solid"}} endIcon={<KeyboardArrowDown />}>
            {getValueString(TIPOPAGO, state.tipo)}
          </Button>
          <Menu
              anchorEl={menuTipo}
              open={Boolean(menuTipo)}
              onClose={()=>setMenuTipo(null)}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: "50%",
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
                },
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
          >
            {objToKeyValue(TIPOPAGO).filter(i=> ![TIPOPAGO.PAGO_BORRADOR, TIPOPAGO.AUSTE_CAPITAL].includes(i.key!) ).map(item=>

                // {(item.key === TIPOPAGO.ABONO_CAPITAL || item.key === TIPOPAGO.SALDAR) && <Divider/>}
                <MenuItem key={item.key}
                          disabled={
                              (item.key === TIPOPAGO.PAGO_INICIAL && !prestamo.inicial) ||
                              (item.key === TIPOPAGO.ABONO_CAPITAL && !!prestamo.pagoPendiente) ||
                              (item.key === TIPOPAGO.SOLO_INTERES && (prestamo.tipoAmortizacion === 4 || !!prestamo.pagoPendiente))
                          }
                          selected={state.tipo === item.key} onClick={()=>handleTipoChange(item.key!)}
                          sx={{
                            borderTop: (item.key === TIPOPAGO.ABONO_CAPITAL || item.key === TIPOPAGO.SALDAR) ? "1px solid #d6d6d6": "none"
                          }}
                >
                  <ListItemIcon>
                    <Checkbox checked={state.tipo === item.key} />
                  </ListItemIcon>
                  <ListItemText>{item.value}</ListItemText>
                </MenuItem>

            )}
          </Menu>



        <MostrarError errors={error}/>

        <DialogContent className={classes.content}>
          {loading && <LoadingProgress vh={false} />}
          <Grid container spacing={3} style={{position:"relative", marginBottom: 15}}>

            <Grid item xs={6}>
              {(state.tipo !== TIPOPAGO.SALDAR && state.tipo !== TIPOPAGO.ABONO_CAPITAL && state.tipo !== TIPOPAGO.PAGO_INICIAL) && <>
                <FormControl fullWidth>
                  <Select
                      native
                      name={"cuotasAPagar"}
                      value={state.cuotasAPagar}
                         onChange={({target})=>setState(prev=>({...prev,abonarSobranteCapital: false,cuotasAPagar: +target.value ?? undefined }))}
                  >
                    {state.tipo === TIPOPAGO.CUOTA_COMPLETA && (prestamo.pagoPendiente ?? 0) &&
                        <option value={0}>{Strings.parcialPendiente}</option>
                    }
                    {cuotasList().map((opt)=>
                        <option value={opt.key} key={opt.key}>{opt.value}</option>
                    )}
                  </Select>
                </FormControl>
              </>}


              {state.tipo === TIPOPAGO.ABONO_CAPITAL &&
                  <Button fullWidth variant="contained" color={"inherit"} disableElevation sx={{fontWeight: 400}}
                          onClick={()=> {
                            let mora =  modificarMora ? 0 : (prestamo.mora ?? 0)
                            setState({...state, monto: (prestamo.capitalActual ?? 0) + mora})
                          }}>
                    {Strings.capital} {Strings.pendiente}: {formatPeso(prestamo.capitalActual)}
                  </Button>
              }
              {/*{(state.tipo === TIPOPAGO.SOLO_INTERES || state.tipo === TIPOPAGO.PAGO_PARCIAL)   &&*/}
              {/*    <FormControlLabel*/}
              {/*                      control={*/}
              {/*                        <Checkbox*/}
              {/*                            name="cerrarCuota"*/}
              {/*                            checked={cerrarCuota || (state.monto>0 && state.monto === prestamo.pagoPendiente)}*/}
              {/*                            onChange={e=>setCerrarCuota(e.target.checked)}*/}

              {/*                        />*/}
              {/*                      }*/}
              {/*                      label={Strings.cerrar+" "+Strings.cuota}*/}
              {/*    />*/}
              {/*}*/}


              {state.tipo === TIPOPAGO.SOLO_INTERES && !!prestamo.montoSeguro &&
                    <FormControlLabel control={<Checkbox name={"incluirSeguro"} checked={state.incluirSeguro} onChange={handleChange} />} label="Incluir Seguro" />
              }

            </Grid>
            <Grid item xs={6}>
              <DateInput
                  name="fecha"
                  value={state.fecha || formatDate(new Date(),"YYYY-MM-DD")}
                  margin={"none"}
                  onChange={handleChange}
                  disabled={!hasPermissionTo(PERSMISOS.pagosCambiarFecha)} native={undefined} clearable={undefined}
                  openTo={undefined} views={undefined} quincenalFijo={undefined}              />
            </Grid>

          </Grid>


          {state.tipo !== TIPOPAGO.PAGO_INICIAL && <>
            <Grid container spacing={0} className={classes.cuotaInteres}>
              <Grid item xs={6} display={"flex"} justifyContent={"space-between"} paddingRight={"5%"} className={!!prestamo?.mora?"text-red":""}>
                <span>{Strings.mora}:</span> <span>{formatPeso(prestamo.mora)}</span>
              </Grid>
              <Grid item xs={6} display={"flex"} justifyContent={"space-between"} paddingLeft={"5%"} className={!!prestamo?.pagoPendiente?"text-blue":""}>
                {/*{(prestamo.pagoPendiente ?? 0) > 0 &&*/}
                <span>{Strings.pendiente}:</span> <span>{formatPeso(prestamo.pagoPendiente)}</span>
                {/*}*/}
              </Grid>

              <Grid item xs={6} display={"flex"} justifyContent={"space-between"} paddingRight={"5%"} >
                <span>{Strings.cuota}:</span> <span>{formatPeso(prestamo.montoCuota)}</span>
              </Grid>
              <Grid item xs={6} display={"flex"} justifyContent={"space-between"} paddingLeft={"5%"}>
                <span>{Strings.interes}:</span> <span>{formatPeso(prestamo.cuotaInteres)}</span>
              </Grid>
            </Grid>
          </>}
          <form onSubmit={submit} id={"formMonto"}>
            <div className={classes.montoInput}>
              <TextFieldCurrency id="monto" fullWidth name="monto"
                                 value={state.monto ?? ""}

                                 disabled={state.tipo === TIPOPAGO.SOLO_INTERES || state.tipo === TIPOPAGO.SALDAR}
                                 // disabled={soloInteres ||
                                 // ["interes","capitalActual","cancelar","pendiente"].includes(state.cuotasAPagar)}
                                 onChange={handleChange}/>
            </div>
          </form>
          {state.tipo === TIPOPAGO.CUOTA_COMPLETA && checkRestante() > 0 &&
              <Box className={classes.abonoRest}>
                  <FormControl size={"small"} >
                    <FormLabel>Abonar {formatPeso(checkRestante())} restante a:</FormLabel>
                    <RadioGroup
                        row
                        id="demo-controlled-radio-buttons-group"
                        name={"abonarSobranteCapital"}
                        value={state.abonarSobranteCapital?"capital":"cuota"}
                        onChange={handleChange}
                    >
                      <FormControlLabel  value="cuota" control={<Radio size={"small"} />} label="Próxima Cuota" />
                      <FormControlLabel value="capital" control={<Radio size={"small"}  />} label="Capital" />
                    </RadioGroup>
                  </FormControl>
              </Box>
          }

          <Grid container spacing={3}>
            {state.tipo !== TIPOPAGO.PAGO_INICIAL && state.tipo !== TIPOPAGO.ABONO_CAPITAL && <>
              {/*<Grid item xs={6} sx={{ position: "relative"}}>*/}
              {/*  {!hasPermissionTo(PERSMISOS.pagosModificarMora) && !state.pin &&*/}
              {/*      <div className={classes.authMask} onClick={()=>setSolAuthModal(true)}/>*/}
              {/*  }*/}
              {/*  <TextFieldCurrency*/}
              {/*      disabled={(!hasPermissionTo(PERSMISOS.pagosModificarMora) && !state.pin) || state.tipo === TIPOPAGO.PAGO_RAPIDO  }*/}
              {/*      label={Strings.mora??""}*/}
              {/*      name="mora"*/}
              {/*      value={state.mora}*/}
              {/*      onChange={handleChange}*/}
              {/*      fullWidth*/}
              {/*  />*/}
              {/*</Grid>*/}
                  <Grid item xs={6} sx={{ position: "relative"}}>
                    {!hasPermissionTo(PERSMISOS.pagosDescuento) && !state.pin &&
                        <div className={classes.authMask} onClick={()=>setSolAuthModal(true)}/>
                    }
                    <TextFieldCurrency disabled={!hasPermissionTo(PERSMISOS.pagosDescuento) && !state.pin }
                                       label={Strings.descuento} name="descuento" value={state.descuento??""} onChange={handleChange} fullWidth/>
                  </Grid>

            </>}
            <Grid item xs={6}>
              <TextFieldCurrency label={Strings.otros} placeholder={Strings.otros} name="otros" value={state.otros} onChange={handleChange} fullWidth/>
            </Grid>
            {modificarMora &&
                <Grid item xs={6}>
                  <TextFieldCurrency label={Strings.mora} placeholder={Strings.mora} name="mora" value={state.mora ?? ""} onChange={handleChange} fullWidth/>
                </Grid>
            }

            <Grid item xs={modificarMora ? 6:12}>
              <div className="form-group">
                <SelectEnum label={Strings.tipoFormaPago} group="tiposFormasPago" name="tipoFormaPago" required={true} value={state.tipoFormaPago} onChange={handleChange}/>
              </div>
            </Grid>
            {solAuthModal &&
                <Grid item xs={12}>
                  <TextField label={Strings.autorizacion} placeholder={"ID"} name="pin" value={state.pin} onChange={handleChange} fullWidth/>
                </Grid>
            }


            {Boolean(getUsuTipo() === TIPOUSUARIO.agente && defaultCajId) === false &&
              <Grid item xs={12}>
                <div className="form-group">
                  <SelectCaja label={Strings.caja} name="cajaId"
                              value={state.cajaId === -1 ? undefined : state.cajaId} onChange={handleChange}/>
                </div>
              </Grid>
            }
          </Grid>
          <div className="form-group">
            <TextField label={Strings.comentario} name="nota" value={state.nota??""}
                       onChange={handleChange}
                       inputProps={{maxLength: 256}}
                       margin="normal" fullWidth/>
          </div>
          <Grid item xs={12} >
            <SelectFiles showImg={false} src={state.adjuntoBase64??""} onChange={(baseb4:string)=>setState({...state, adjuntoBase64: baseb4})} defaultImgProp={defaultImg}/>
          </Grid>
        </DialogContent>
        {/*{state.monto >= prestamo.capitalActual &&*/}
        {/*  <div className={classes.alertText}>{Strings.pagoCancelaMsj}</div>*/}
        {/*}*/}


        {!loading && !!msj &&
            <div className={classes.alertText}>{msj}</div>
        }
        {state.tipo !== TIPOPAGO.PAGO_INICIAL && <>
          <Box display={"flex"} justifyContent={"end"} marginRight={1}>
              <div className={classes.totalApagar}>
                {Strings.totalApagar}: &nbsp;

                    <span>
                      {formatPeso(((+state.monto || 0) + (state.otros || 0) - (state.descuento || 0)) + (modificarMora ? (state.mora ??0) : 0) )}
                    </span>
              </div>
          </Box>
        </>}
        <DialogActions className={classes.dialogActions}>
            <Button size={"small"} fullWidth sx={{maxWidth: 160}} variant={"outlined"} color="warning" startIcon={<Close/>}  disabled={loading} onClick={()=>navigate(-1)} >
              {Strings.cancelar}
            </Button>
            <Button size={"small"} fullWidth variant={"outlined"} color="primary" startIcon={<Save/>} type={"submit"} form={"formMonto"} disabled={loading}>
              {Strings.agregar} {Strings.pago}
            </Button>
        </DialogActions>

      </Dialog>
  );
}
